// EstimateDocumentUpload Component

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Dropzone from 'dropzone'

import Util from '../../../lib/util.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class EstimateDocumentUpload extends Component {
  constructor (props) {
    super(props)

    this.state = {
      progressValue: 0,
      upload: false
    }

    this.dropZone = null
    this._references = {
      refUpload: React.createRef()
    }
  }

  static get propTypes () {
    return {
      className: PropTypes.string,
      onDeleteClick: PropTypes.func,
      uploadError: PropTypes.func,
      uploadSuccess: PropTypes.func,
      error: PropTypes.bool,
      fileObj: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      className: 'content',
      onDeleteClick: null,
      uploadError: null,
      uploadSuccess: null,
      error: false,
      fileObj: null
    }
  }

  componentDidMount () {
    if (this._references.refUpload.current) {
      this.dropZone = new Dropzone(
        ReactDOM.findDOMNode(this._references.refUpload.current),
        {
          paramName: 'uri',
          url: '/api/uploads',
          uploadMultiple: false,
          previewTemplate: '<div class="dz-preview"></div>',
          hiddenInputContainer: '.content',
          clickable: ['.estimate-documentupload > .content'],
          acceptedFiles: 'application/pdf'
        }
      )

      this.dropZone.on('error', this._onError.bind(this))
      this.dropZone.on('uploadprogress', this._onProgress.bind(this))
      this.dropZone.on('success', this._onSuccess.bind(this))
    }
  }

  componentWillUnmount () {
    if (this.dropZone) {
      this.dropZone.disable()
      this.dropZone = null
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!nextProps.fileObj) {
      this.setState({ upload: false })
    }
  }

  render () {
    if (!this.state.upload && !this.props.fileObj) {
      return (
        <div
          className='estimate-documentupload'
          ref={this._references.refUpload}
        >
          <div className='content'>
            <i className='icon icon-form-attachment' />
            <span className='info'>
              <IntlMessage ident='estimate.form.attachmentInfo' />
            </span>
          </div>
        </div>
      )
    }

    return this._renderUploadedContent()
  }

  /* Private functions */
  _renderUploadedContent () {
    if (this.state.upload || this.props.fileObj) {
      return (
        <div className='estimate-documentuploaded'>
          <div className='content'>
            <i className='icon icon-common-success-tick' />
            <div className='title'>{this._renderFile()}</div>
            <span className='sub-info'>
              <IntlMessage ident='estimate.form.fileUploadedInfo' />
            </span>
          </div>
          <IconButton
            type='primary'
            icon='header-upload-delete'
            canHover
            className='act-avatar-delete'
            onClick={this._onDeleteClick.bind(this)}
          />
        </div>
      )
    }
    return this.renderErrorMsg()
  }

  _renderFile () {
    if (this.props.fileObj && this.props.fileObj !== '') {
      return <h2 className='title'>{this.props.fileObj.fileDisplayName}</h2>
    }

    return ''
  }

  renderErrorMsg () {
    if (this.props.error !== undefined && this.props.error) {
      return <p className='upload-error'>{this.props.error}</p>
    }

    return ''
  }

  _onSuccess (file, message, e) {
    const ext = Util.getExtension(message.id)
    if (ext === 'pdf') {
      this.setState({
        progressValue: 0,
        upload: true
      })

      if (this.props.uploadSuccess) {
        this.props.uploadSuccess(file, message, e)
      }
    } else {
      this.setState({ upload: false })
    }
  }

  _onError (file, message, _e) {
    this.setState({ upload: false })

    if (this.props.uploadError) {
      this.props.uploadError(file, message)
    }
  }

  _onProgress (file, progress, _e) {
    this.setState({ progressValue: progress })
  }

  _onDeleteClick (e) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({ upload: false })
    if (this.props.fileObj) {
      this.props.fileObj.title = ''
      this.props.fileObj.fileName = ''
      this.props.fileObj.url = ''
    }

    if (this.props.onDeleteClick) {
      this.props.onDeleteClick(e)
    }
  }
}

export default EstimateDocumentUpload
